<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";
  import BookmarkPricing from "./BookmarkPricing.svelte";
  import Card from "../../../Core/Card.svelte";
  import { Pricing } from "../../../../utils/Constant/Constant";
  import SimplePricingCard from "./SimplePricingCard.svelte";
  import PricingList from "./PricingList.svelte";

</script>
<BookmarkPricing />
<Container fluid>
    <Row>
        <SimplePricingCard />
        <Col sm="12">
            <Card headerTitle={Pricing} cardBodyprops="pricing-content pricing-col" cardHeaderprops="pb-0">
                <div slot="contentbody" class="row">
                    <PricingList/>
                </div>
            </Card>
        </Col>
    </Row>
</Container>